import React, { useEffect, useState } from 'react';

import { ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';

type Props = {
  noHandler: () => void;
  yesActive: boolean;
  yesHandler: () => void;
  className?: string;
  dataTest?: string;
  disabled?: boolean;
};

export default function YesAndNo({
  className,
  noHandler,
  yesHandler,
  yesActive,
  dataTest,
  disabled,
}: Props): JSX.Element {
  const NO = 'no';
  const YES = 'yes';

  const [buttonState, setButtonState] = useState({
    value: yesActive ? YES : yesActive === false ? NO : null,
  });

  // Sync internal state with yesActive prop when it changes
  useEffect(() => {
    setButtonState({
      value: yesActive ? YES : yesActive === false ? NO : null,
    });
  }, [yesActive]);

  function onToggleButtonGroupChange(value: string | Array<string>): void {
    const newValue = typeof value === 'string' ? value : value[0];

    if (newValue === NO) {
      setButtonState({ value: NO });
      noHandler();
    } else if (newValue === YES) {
      setButtonState({ value: YES });
      yesHandler();
    }
  }

  return (
    <ToggleButtonGroup
      css={{ width: '100%' }}
      className={className}
      onValueChange={onToggleButtonGroupChange}
      data-test={dataTest}
      value={buttonState.value}
      aria-label="yes or no"
    >
      <ToggleButton aria-label={YES} value={YES} data-test="yes-button" disabled={disabled}>
        Yes
      </ToggleButton>
      <ToggleButton aria-label={NO} value={NO} data-test="no-button" disabled={disabled}>
        No
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
